(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ManageFlightStats',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('input.flight-alert-toggle').on('change', function flightAlertsToggle() {
			var $events = $(this).parents('.flight-alert-controls').find('.flight-alert-events');
			$events.find('input[type="checkbox"]:not(.no-enable)').prop('disabled', !this.checked);

			if (this.checked) {
				$events.slideDown();
			} else {
				$events.slideUp();
			}
		});

		$('input.toggle-all-components').on('change', function toggleAll() {
			$('input.flight-alert-toggle').prop('checked', (this.value === '1')).trigger('change');
			$('.flight-alert-events input[type="checkbox"]:not(.no-enable)').prop('checked', true);
		});
	};
}(jQuery, window.Adzuki || {}));
